import React, { useContext } from 'react';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';
import CustomIcon from '../CustomIcon/CustomIcon';
import styles from './BookingNotfound.style';

export default function BookingNotFound({ title, pmsMessage }) {
  const {
    actions: { translate },
  } = useContext(LanguageContext);
  const { state: theme } = useContext(ThemeContext);
  const { className: themeClassName, styles: themeStyle } = styles(theme);

  return (
    <>
      <div id="booking-not-found" className={`${themeClassName} no-results`}>
        <CustomIcon size={100} type={'info'} color={theme.titleColor}></CustomIcon>
        <div className={`${themeClassName} no-results-texts`}>
          {pmsMessage ? (
            <p className={`${themeClassName} no-results-title`}>{pmsMessage}</p>
          ) : (
            <>
              <p className={`${themeClassName} no-results-title`}>
                {title || translate('bookingList.noDispoError1')}
              </p>
              <p className={`${themeClassName} no-results-title`}>
                {translate('bookingList.noDispoError2')}
              </p>
              <strong>
                <p className={`${themeClassName} no-results-title`}>
                  {translate('bookingList.noDispoError3')}
                </p>
              </strong>
            </>
          )}
        </div>
      </div>
      {themeStyle}
    </>
  );
}
